module.exports = __webpack_public_path__ + "static/img/13.29dfdaa5.jpg";